import { z } from 'zod';
export const IsVolunteeringQueryParamSchema = z.object({
    isVolunteering: z.enum(['true', 'false']).default('false').optional()
});
//# sourceMappingURL=isVolunteeringQueryParamSchema.js.map